import { render, staticRenderFns } from "./DoorLeaves.vue?vue&type=template&id=304f1262&scoped=true"
import script from "./DoorLeaves.vue?vue&type=script&lang=ts"
export * from "./DoorLeaves.vue?vue&type=script&lang=ts"
import style0 from "./DoorLeaves.vue?vue&type=style&index=0&id=304f1262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f1262",
  null
  
)

export default component.exports